module.exports = __webpack_public_path__ + "static/n5impactvideo_x264-eb90450f3ef0feebd626195d6157e601.mp4";